import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SecurityToken } from "../../components/securite";
import Loading from "../../components/loading";
import { withTranslation } from "react-i18next";
import styles from "./homeSSO.module.css";
import imgGuest from "../../image/guest.png";
import imgOrga from "../../image/orga.png";

const HomeSSO = (props) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(SecurityToken(props.history));
    document.title = `${props.t("home_sso.header")} - Wifi Guest`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { t } = props;
  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }
  return (
    <div className={styles.container}>
      <Link to="account-sso">
        <div className={styles.card}>
          <div className={styles.card__img}>
            <img src={imgGuest} alt="Icone invité sur fond orange" />
          </div>
          <h4 className={styles.card__title}>{t("home_sso.account")}</h4>
        </div>
      </Link>
      <Link to="event-sso">
        <div className={styles.card}>
          <div className={styles.card__img}>
            <img src={imgOrga} alt="Icone de calendrier" />
          </div>
          <h4 className={styles.card__title}>{t("home_sso.event")}</h4>
        </div>
      </Link>
    </div>
  );
};

export default withTranslation()(HomeSSO);
